

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404 - Stranica nije pronađena</h1>
      <p>Tražena adresa ne postoji ili je premještena.</p>
    </div>
  );
};

export default NotFound;